import axiosInstance from './axiosInstance';

const attendanceService = {
    // WhatsApp Group Management
    getWhatsAppGroups: async () => {
        const response = await axiosInstance.get('/attendance/whatsapp-groups');
        return response.data;
    },

    updateWhatsAppGroups: async (data) => {
        const response = await axiosInstance.post('/attendance/whatsapp-groups', data);
        return response.data;
    },

    // Student Group Assignment
    assignStudentToGroup: async (data) => {
        const response = await axiosInstance.post('/attendance/assign-group', data);
        return response.data;
    },

    getStudentGroups: async (studentId) => {
        const response = await axiosInstance.get(`/attendance/student-groups/${studentId}`);
        return response.data;
    },

    // Attendance Sessions
    startAttendance: async (data) => {
        const response = await axiosInstance.post('/attendance/start', data);
        return response.data;
    },

    markPresent: async (sessionId) => {
        const response = await axiosInstance.post('/attendance/mark-present', { sessionId });
        return response.data;
    },

    // Absence History
    getStudentAbsenceHistory: async (studentId) => {
        const response = await axiosInstance.get(`/attendance/history/${studentId}`);
        return response.data.data;
    },

    checkActiveSession: async () => {
        const response = await axiosInstance.get('/attendance/check-active');
        return response.data;
    },

    getRecentSessions: async (matier = '') => {
        const params = matier ? { matier } : {};
        const response = await axiosInstance.get('/attendance/recent', { params });
        return response.data;
    },

    async getAbsentees(sessionId) {
        const response = await axiosInstance.get(`/attendance/absentees/${sessionId}`);
        return response.data;
    },

    async sendAbsentSMS(sessionId, body = {}) {
        const response = await axiosInstance.post(`/attendance/send-absent-sms/${sessionId}`, body);
        return response.data;
    },

    async sendPresentSMS(sessionId, body = {}) {
        const response = await axiosInstance.post(`/attendance/send-present-sms/${sessionId}`, body);
        return response.data;
    },

    async sendAbsentWhatsApp(sessionId, body = {}) {
        const response = await axiosInstance.post(`/attendance/send-whatsapp-absent/${sessionId}`, body);
        return response.data;
    },

    async sendManualSMS(data) {
        const response = await axiosInstance.post('/sms/manual-send', data);
        return response.data;
    }
};

export default attendanceService;
